export default __webpack_public_path__ + "static/media/tealeaf-right-bottom.ff985466.png";